import { autorun, makeAutoObservable } from "mobx";

export class PinnedClients {
  static LOCAL_STORAGE_KEY = "pinnedClients";

  pinned = new Set<string>();

  get size(): number {
    return this.pinned.size;
  }

  constructor() {
    makeAutoObservable(this);

    this.hydrate();
    autorun(() => this.save());
  }

  pin(id: string): void {
    this.pinned.add(id);
  }

  unpin(id: string): void {
    this.pinned.delete(id);
  }

  toggle(id: string): void {
    if (this.has(id)) this.unpin(id);
    else this.pin(id);
  }

  has(id: string): boolean {
    return this.pinned.has(id);
  }

  private hydrate() {
    const stored = localStorage.getItem(PinnedClients.LOCAL_STORAGE_KEY);
    if (stored) {
      this.pinned = new Set(JSON.parse(stored));
    }
  }

  private save() {
    localStorage.setItem(
      PinnedClients.LOCAL_STORAGE_KEY,
      JSON.stringify(this.pinned)
    );
  }
}

const pinnedClients = new PinnedClients();
export default pinnedClients;
